import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const tooltipSlotProps = {
  tooltip: {
    sx: {
      maxWidth: 360,
      fontSize: "0.8125rem",
      lineHeight: 1.5,
      py: 1.25,
      px: 1.5,
      bgcolor: "rgba(15, 23, 42, 0.92)",
      "& .MuiTooltip-arrow": { color: "rgba(15, 23, 42, 0.92)" },
    },
  },
};

type Props = {
  title: string;
  summary: string;
  detail: string;
  /** MUI sx for the title line */
  titleSx?: Record<string, unknown>;
};

/**
 * Bold title + italic summary (always visible); hover for fuller regulatory / UX explanation.
 * Same pattern as activity-family rows across wizard steps 2–4.
 */
export function WizardOptionWithBlurb({ title, summary, detail, titleSx }: Props) {
  return (
    <Tooltip
      title={detail}
      placement="top"
      arrow
      enterNextDelay={200}
      enterTouchDelay={400}
      componentsProps={tooltipSlotProps}
    >
      <Box
        component="span"
        sx={{
          cursor: "help",
          display: "block",
          flex: 1,
          minWidth: 0,
          borderRadius: "6px",
          margin: "-2px",
          padding: "2px",
          transition: "background-color 0.15s ease",
          "&:hover": { backgroundColor: "rgba(10, 130, 157, 0.06)" },
        }}
      >
        <Typography
          component="span"
          sx={{
            color: "#1e3a4c",
            display: "block",
            fontSize: "13px",
            fontWeight: 600,
            lineHeight: 1.3,
            ...titleSx,
          }}
        >
          {title}
        </Typography>
        <Typography
          component="span"
          sx={{
            color: "#5b6b7a",
            display: "block",
            fontSize: "11.5px",
            fontStyle: "italic",
            lineHeight: 1.45,
            marginTop: "3px",
          }}
        >
          {summary}
        </Typography>
      </Box>
    </Tooltip>
  );
}
